module.exports = __webpack_public_path__ + "img/as-booking.3438ac1a.jpg";